import { __assign, __extends, __spreadArray } from "tslib";
import React from "react";
import moment from "moment";
import { Image, Platform, Text, TextInput, View } from "react-native";
import PnmacUibutton from "../../Uibutton/PnmacUibutton";
import PnmacSelect from "../../Select/PnmacSelect";
import styles from "../PnmacMessageCenter.styles.js";
import colors from "../../colors.js";
import PnmacText from "../../Typography/PnmacText";
import PnmacCard from "../../Card/PnmacCard";
import { FileUpload } from "../FileUpload/FileUpload";
import PnmacHtmlToNative from "../../HtmlToNative/PnmacHtmlToNative";
import PnmacSectionListView from '../../SectionListView';
import { PnmacRowHeader } from '../../RowHeader';
import { PnmacModal, PnmacUIButton } from "pnmac-universal-components";
import { textStyle } from '../../v2/theme';
import BannerView from '../../v2/BannerView';
var Compose = /** @class */function (_super) {
  __extends(Compose, _super);
  function Compose(props) {
    var _this = _super.call(this, props) || this;
    _this.onChangeHandler = function (e) {
      var _a;
      var beforeReplace = Platform.OS === "web" ? e.target.files[0] : e;
      (_a = beforeReplace === null || beforeReplace === void 0 ? void 0 : beforeReplace.name) === null || _a === void 0 ? void 0 : _a.replace(/[/\\?*:|"<>]/g, '');
      _this.setState({
        selectedFile: beforeReplace
      });
      var chosenFiles = Array.prototype.slice.call(Platform.OS === "web" ? e.target.files : [e]);
      if (chosenFiles[0] != undefined || chosenFiles[0] != null) {
        var isValidFile = _this.checkAndValidateFile(chosenFiles);
        if (isValidFile) {
          _this.handleUploadFiles(chosenFiles);
        }
      }
    };
    _this.renderTextInputCounter = function () {
      if (_this.state.message && _this.state.message.length > 0) {
        return /*#__PURE__*/React.createElement(Text, {
          style: {
            color: colors.darkGray
          }
        }, _this.state.message ? _this.state.message.length : 0, "/(", _this.props.maxLength, ")");
      } else return null;
    };
    _this.handleClick = function () {
      _this.props.navigate("inbox");
    };
    _this.checkAndValidateFile = function (addedFile) {
      var fileTypes = ".pdf, .doc, .docx, .png, .jpg, .tif, .txt, .jpeg, .xls, .xlsm, .xlsx, .ppt, .pptx, .csv, .PDF, .DOC, .DOCX, .PNG, .JPG, .TIF, .TXT, .JPEG, .XLS, .XLSM, XLSX, .PPT, .PPTX, .CSV";
      var fileTypesList = fileTypes.split(", ");
      var validFileType = false;
      var validFileSize = true;
      var fileNotRecognized = false;
      var fileSize = addedFile[0].size;
      var maxfileSize = 20971520;
      for (var i = 0; i < fileTypesList.length; i++) {
        if (addedFile[0].name.indexOf(fileTypesList[i]) > 0) {
          validFileType = true;
          break;
        }
      }
      if (fileSize > maxfileSize || _this.state.uploadedFileSize > maxfileSize) {
        validFileSize = false;
      }
      if (fileNotRecognized || !validFileSize || !validFileType) {
        _this.setState({
          errorText: 'We’re sorry, this didn’t attach to your message. Try again. (Typical attachments are pdf,doc,docx,xls,xlsx,xlsm,csv,tif,jpg,jpeg,png,ppt,pptx,txt. Max file size is 20 MB.)'
        });
        _this.setState({
          modalState: true
        });
        return;
      }
      if (validFileType && validFileSize) {
        return true;
      }
    };
    _this.handleUploadFiles = function (files) {
      var uploaded = __spreadArray([], _this.state.uploadedFiles, true);
      files.some(function (file) {
        if (uploaded.findIndex(function (f) {
          return f.name === file.name;
        }) === -1) {
          _this.setState({
            uploadedFiles: _this.state.uploadedFiles.concat(file)
          }, function () {
            _this.setState({
              uploadedFileSize: _this.state.uploadedFileSize + file.size
            });
            console.log('uploadedFileSize: ', _this.state.uploadedFileSize);
          });
        }
      });
    };
    _this.state = {
      subject: props.rowdata ? props.rowdata[5] : "",
      message: "",
      messageId: props.rowdata ? props.rowdata[6] : "",
      date: moment(new Date()).format("MM/DD/YYYY"),
      from: "",
      direction: 200269,
      recieved: moment(new Date()).format("MM/DD/YYYY"),
      loanId: props.loanNumber,
      documentId: 0,
      selectedFile: null,
      submitted: false,
      uploadedFiles: [],
      isFileNotRecognized: false,
      isValidFileType: false,
      isValidFileSize: false,
      uploadedFileSize: 0
    };
    _this.fileref = /*#__PURE__*/React.createRef();
    _this.expRefList = /*#__PURE__*/React.createRef();
    return _this;
  }
  Compose.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      contactTo = _a.contactTo,
      regardingLoanId = _a.regardingLoanId,
      subject = _a.subject,
      placeHolderText = _a.placeHolderText,
      attachFiles = _a.attachFiles,
      communicationBtnYouAndDebtCollector = _a.communicationBtnYouAndDebtCollector,
      fAQInfo = _a.fAQInfo,
      insuranceInfo = _a.insuranceInfo,
      subjects = _a.subjects,
      loanNumber = _a.loanNumber,
      typeOfContact = _a.typeOfContact,
      submittMessage = _a.submittMessage,
      sendMessageText = _a.sendMessageText,
      buttonMode = _a.buttonMode,
      small = _a.small,
      reply = _a.reply,
      rowdata = _a.rowdata,
      cancel = _a.cancel,
      showModal = _a.showModal,
      isModification = _a.isModification,
      fromChat = _a.fromChat,
      chatLog = _a.chatLog,
      showCompose = _a.showCompose,
      isPennyWiseMode = _a.isPennyWiseMode;
    var DATAEXPANDABLELIST = [{
      title: "Messages",
      data: [{
        header: "Messages",
        body: rowdata ? rowdata[4] : null
      }]
    }];
    var submit = !this.state.message || !this.state.subject || this.state.subject == "" || isPennyWiseMode;
    if (subjects) subjects.forEach(function (s) {
      return s.color = 'white';
    });
    return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacCard, {
      style: {
        backgroundColor: "#FFF",
        borderRadius: 10,
        shadowColor: "rgba(0,0,0, .08)",
        shadowOffset: {
          height: 4,
          width: 2
        },
        shadowOpacity: 1,
        shadowRadius: 12
      }
    }, !showCompose && /*#__PURE__*/React.createElement(View, {
      style: styles.composeHeader
    }, !reply && /*#__PURE__*/React.createElement(View, {
      accessible: true,
      accessibilityLabel: regardingLoanId || "Regarding Loan:",
      style: small ? styles.textviewSmall : styles.textview
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextTitle
    }, regardingLoanId || "Regarding Loan:"), /*#__PURE__*/React.createElement(View, {
      accessible: true,
      accessibilityLabel: String(loanNumber) || "0",
      style: {
        marginTop: 10,
        marginLeft: small ? 0 : 20
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription
    }, loanNumber || "0"))), /*#__PURE__*/React.createElement(View, {
      accessible: true,
      accessibilityLabel: subject || "Subject:",
      style: small ? styles.textviewSubjSmall : styles.textViewSubj
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextTitle
    }, subject || "Subject:"), /*#__PURE__*/React.createElement(View, {
      style: {
        maxWidth: "94%",
        width: "auto",
        marginLeft: small ? 0 : 20,
        marginTop: small ? 10 : 20
      }
    }, !!reply ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, {
      style: textStyle.defaultTextDescription
    }, rowdata ? rowdata[3] : null)) : /*#__PURE__*/React.createElement(View, {
      style: {
        borderWidth: 1,
        borderRadius: 10,
        padding: 8
      }
    }, /*#__PURE__*/React.createElement(PnmacSelect, {
      Icon: function () {
        return /*#__PURE__*/React.createElement(Image, {
          source: require('../../assets/downarrow.png')
        });
      },
      accessibilityLabel: "Select a subject",
      style: {
        width: 50,
        inputAndroid: {
          color: "black"
        }
      },
      onValueChange: function (subject) {
        if (Platform.OS !== 'ios') {
          if (subject != '' && subject != null) {
            switch (String(subject)) {
              case '202421':
                showModal("NoNeedBillUpload");
                break;
              case '200244':
                if (isModification) {
                  showModal("NoModificationDocumentsUpload");
                }
                break;
              case '200248':
                showModal("PMIDivId");
                break;
              case '202420':
                showModal('NoNeedInsuranceBillUpload');
                break;
              default:
                break;
            }
          }
        }
        _this.setState({
          subject: subject
        });
      },
      onClose: function (_a) {
        var subject = _a.value;
        if (subject != '' && subject != null) {
          switch (String(subject)) {
            case '202421':
              showModal("NoNeedBillUpload");
              break;
            case '200244':
              if (isModification) {
                showModal("NoModificationDocumentsUpload");
              }
              break;
            case '200248':
              showModal("PMIDivId");
              break;
            case '202420':
              showModal('NoNeedInsuranceBillUpload');
              break;
            default:
              break;
          }
        }
        _this.setState({
          subject: subject
        });
      },
      value: this.state.subject || '',
      items: (subjects || [{
        label: "Loan",
        value: "loan"
      }, {
        label: "Escrow",
        value: "escrow"
      }, {
        label: "Payments",
        value: "payments"
      }]).map(function (s) {
        return {
          label: s.text || s.label,
          value: s.value
        };
      })
    }))))), !reply && fAQInfo && !showCompose && (/*#__PURE__*/React.createElement(BannerView, {
      style: {
        marginHorizontal: 20,
        marginTop: 20
      }
    }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
      value: fAQInfo,
      navigation: this.props.reactNavigation
    }))), !reply && insuranceInfo && !showCompose && this.state.subject == "202420" && (/*#__PURE__*/React.createElement(BannerView, {
      style: {
        marginHorizontal: 20,
        marginTop: 20
      }
    }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
      value: insuranceInfo,
      navigation: this.props.reactNavigation
    }))), /*#__PURE__*/React.createElement(View, {
      style: styles.textAreaContainer
    }, /*#__PURE__*/React.createElement(View, {
      style: styles.textArea
    }, showCompose ? /*#__PURE__*/React.createElement(Text, {
      style: textStyle.defaultTextDescription
    }, showCompose()) : /*#__PURE__*/React.createElement(TextInput, {
      accessibilityLabel: "Text Input",
      style: {
        height: 130,
        borderWidth: 1,
        borderColor: "#808080",
        backgroundColor: "#FFF",
        borderRadius: 10,
        padding: 20
      },
      multiline: true,
      numberOfLines: 10,
      underlineColorAndroid: "transparent",
      placeholder: placeHolderText || "Please type your message here, and if you are going to attach files you must tell us what the documents are and why you are submitting them.",
      onChangeText: function (message) {
        if ((message === null || message === void 0 ? void 0 : message.length) <= _this.props.maxLength) _this.setState({
          message: message
        });
      },
      value: this.state.message
    })), !showCompose && /*#__PURE__*/React.createElement(View, {
      style: styles.disclaimerCounter
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        alignSelf: "flex-end"
      }
    }, this.renderTextInputCounter()), /*#__PURE__*/React.createElement(View, {
      style: {
        paddingTop: 10
      },
      accessible: true,
      accessibilityLabel: communicationBtnYouAndDebtCollector || "*This communication is between you and a debt collector. Deletes after 90 days of inactivity"
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription
    }, communicationBtnYouAndDebtCollector || "*This communication is between you and a debt collector. Deletes after 90 days of inactivity"))), fromChat || (rowdata ? rowdata[8] : []).length > 0 ? /*#__PURE__*/React.createElement(View, {
      style: styles.disclaimer
    }, (chatLog || (rowdata ? rowdata[8] : [])).map(function (e, i) {
      return /*#__PURE__*/React.createElement(View, {
        accessible: true,
        accessibilityLabel: e.text,
        key: i
      }, _this.props.renderChatLog ? _this.props.renderChatLog(e.text) : /*#__PURE__*/React.createElement(Text, {
        style: textStyle.defaultTextDescription
      }, e.text));
    })) : null), !showCompose && /*#__PURE__*/React.createElement(View, {
      style: small ? styles.composeFooterSmall : styles.composeFooterLarge
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        width: 300,
        padding: 15
      },
      accessibilityLabel: 'FileUpload'
    }, /*#__PURE__*/React.createElement(FileUpload, {
      onChangeHandler: this.onChangeHandler,
      type: "file",
      ref: this.fileref
    }), /*#__PURE__*/React.createElement(PnmacUibutton, {
      accessibilityLabel: attachFiles || "Attach Files",
      hoverColor: "white",
      mode: buttonMode || "contained",
      onPress: function () {
        return _this.fileref.current.click();
      }
    }, attachFiles || "Attach Files"), this.state.uploadedFiles.map(function (file) {
      var _a;
      return /*#__PURE__*/React.createElement(View, {
        key: (_a = file.name) === null || _a === void 0 ? void 0 : _a.replace(/[/\\?*:|"<>]/g, '')
      }, /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(Image, {
        style: {
          width: 12,
          height: 12,
          margin: 2
        },
        source: require("../../assets/paperclip.png")
      }), file === null || file === void 0 ? void 0 : file.name));
    })), /*#__PURE__*/React.createElement(View, {
      style: {
        width: 300,
        padding: 15
      }
    }, /*#__PURE__*/React.createElement(PnmacUibutton, {
      accessibilityLabel: 'Cancel button',
      hoverColor: "white",
      loading: this.state.submitted,
      mode: "outlined",
      onPress: this.handleClick
    }, "Cancel")), /*#__PURE__*/React.createElement(View, {
      style: {
        width: 300,
        padding: 15
      }
    }, /*#__PURE__*/React.createElement(PnmacUibutton, {
      accessibilityLabel: (sendMessageText || "Submit") + ' button',
      hoverColor: "white",
      loading: this.state.submitted,
      mode: "contained",
      disabled: submit,
      onPress: function () {
        return _this.setState({
          submitted: true
        }, function () {
          return submittMessage(_this.state, reply);
        });
      }
    }, sendMessageText || "Submit")))), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacModal, {
      "aria-labelledby": "transition-modal-title",
      "aria-describedby": "transition-modal-description",
      // className={classes.modal}
      open: this.state.modalState,
      closeAfterTransition: true
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        backgroundColor: "#fff",
        padding: 20,
        borderRadius: 1
        // maxWidth: screen.width < 480 ? '85%' : 440
      }
    }, /*#__PURE__*/React.createElement(View, {
      accessible: true,
      accessibilityLabel: "Document Upload Message:"
    }, /*#__PURE__*/React.createElement(Text, {
      style: __assign({
        marginBottom: 15
      }, textStyle.defaultTextTitle)
    }, "Document Upload Message:"), /*#__PURE__*/React.createElement(Text, {
      style: textStyle.defaultTextDescription
    }, this.state.errorText)), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacUIButton, {
      accessibilityRole: "button",
      "aria-role": "button",
      accessibilityLabel: "Close button",
      "aria-label": "Color",
      mode: "outlined",
      idTag1: "btnModalPopupOK",
      style: {
        minWidth: "40%",
        marginTop: 50
      },
      onPress: function () {
        _this.setState({
          modalState: false
        });
      }
    }, "Close")))))), /*#__PURE__*/React.createElement(View, null, reply && /*#__PURE__*/React.createElement(View, {
      style: {
        marginTop: 20,
        borderRadius: 10,
        backgroundColor: "#FFF",
        boxShadow: "rgba(0, 0, 0, 0.08) 2px 4px 12px"
      }
    }, /*#__PURE__*/React.createElement(PnmacSectionListView, {
      idTag1: 'allTransactionBreakDown',
      ref: this.expRefList,
      data: DATAEXPANDABLELIST,
      collapsableSections: true,
      renderItem: function (_a, collapsed) {
        var item = _a.item;
        if (collapsed === null || collapsed === void 0 ? void 0 : collapsed.some(function (s) {
          return s == item.header;
        })) {
          return /*#__PURE__*/React.createElement(View, {
            style: {
              padding: 20,
              display: "flex",
              flexDirection: "column",
              flex: 1,
              justifyContent: "center"
            }
          }, item.body);
        } else {
          return null;
        }
      },
      renderSectionHeader: function (_a) {
        var _b, _c;
        var title = _a.section.title;
        var open = ((_c = (_b = _this.expRefList) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.state.collapsed.indexOf(title)) > -1;
        return /*#__PURE__*/React.createElement(PnmacRowHeader, {
          rowHeaderContainerStyles: {
            backgroundColor: "transparent",
            paddingLeft: 10,
            marginTop: 0,
            marginBottom: 0,
            borderBottomWidth: open ? 1 : 0,
            borderRadius: 0,
            borderBottomColor: "#EFEFEF"
          },
          onClickExpand: function () {
            var _a;
            return (_a = _this.expRefList) === null || _a === void 0 ? void 0 : _a.current.collapseItem(title);
          },
          item: /*#__PURE__*/React.createElement(View, {
            accessible: true,
            accessibilityLabel: title,
            id: title,
            style: {
              paddingLeft: 10,
              alignSelf: "center"
            }
          }, /*#__PURE__*/React.createElement(Text, {
            style: textStyle.defaultTextTitle
          }, title)),
          isExpand: open
        });
      }
    }))));
  };
  return Compose;
}(React.Component);
export default Compose;